import * as actionTypes from './actionTypes';
import { autenticationService } from './services';
import { actionsModalError } from '@app/src/common/modalError';
import { fetchValidateAccess } from '@app/src/common/session';

const activeAccountRequest = () => ({
  type: actionTypes.ACTIVE_ACCOUNT_REQUEST
});

const activeAccountFailure = () => ({
  type: actionTypes.ACTIVE_ACCOUNT_FAILURE
});

const activeAccountSuccess = (data) => ({
  type: actionTypes.ACTIVE_ACCOUNT_SUCCESS,
  data
});

export const fetchAccountActive = (json) => {
  return async dispatch => {
    dispatch(activeAccountRequest());
    await dispatch(fetchValidateAccess());
    try {
      const data = await autenticationService.post(json);
      if (data.error) {
        dispatch(activeAccountFailure());
      } else {
        dispatch(activeAccountSuccess({message:'listo'}));
      }
    } catch(error) {
      console.log(error, 'error')
      dispatch(actionsModalError.openModalError());
      dispatch(activeAccountFailure());
    }
  }
};
